module.exports = __webpack_public_path__ + "63726a69fa60cb67459140ccaf679f96.ttf";